import { alpha } from "@mui/material/styles";

export const whiteCardSx = {
    p: 3,
    borderRadius: 3,
    border: "1px solid #eef0f3",
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.06), 0 4px 12px rgba(16, 24, 40, 0.08)",
    backgroundColor: "#fff",
};

export const createColoredCardSx = (color: string) => {
    const coloredCardSx = {
        p: 3,
        borderRadius: 3,
        boxShadow: `0 4px 14px ${alpha(color, 0.35)}`,
        backgroundColor: color,
    };
    return coloredCardSx;
};
